import React from 'react';
import ContentContainer from '../ContentContainer/ContentContainer';
import PFSContactCta from '../PFSContactCta/PFSContactCta';
import PFSServiceHeader from '../PFSServiceHeader/PFSServiceHeader';
import PFSServicePoints from '../PFSServicePoints/PFSServicePoints';
import PFSWhyChoosePFS from '../PFSWhyChoosePFS/PFSWhyChoosePFS';
import globalStyles from '../../styles/global.module.css';
import PFSMeetTheTeam from '../PFSMeetTheTeam/PFSMeetTheTeam';

import calculatorImage from './calculator.jpg'
import { useBreadcrumb } from '../../hooks/useBreadcrumb';
import { WhatWeDoBreadcrumb } from '../PFSWhatWeDoIndex/PFSWhatWeDoIndex';
import { useLocation } from 'react-router-dom';

const PFSWhatWeDoFinOps = () => {
  const { pathname } = useLocation();

  useBreadcrumb([WhatWeDoBreadcrumb, {
    label: "Financial Operations",
    url: pathname
  }]);

  return (
    <div
      data-testid='PFSWhatWeDoFinOps'
    >
      <ContentContainer>
        <PFSServiceHeader title='Solving for the Modern Insurance Agency.' subtitle='Financial Operations' />
        <div className={globalStyles.IntroContainer}>
          <img alt='A calculator' src={calculatorImage} className={globalStyles.IntroImage} />
          <div className={globalStyles.IntroText}>
            <p>At PFS Global, we understand that managing the financial operations of your insurance agency can be complex and time-consuming. That's why our FinOps team offers expert services tailored to your specific needs. By leveraging your Agency Management System effectively, we provide the tools and insights necessary to make informed decisions for your agency's success.</p>
            <p>With PFS Global, you can trust that your financial operations are in expert hands, freeing you to focus on what you do best: running your agency. Contact us today to discover how we can support your financial goals.</p>
          </div>
        </div>
        <PFSServicePoints
          title='Bookkeeping - Income Tax Cash Basis'
          points={[
            'Trust Accounting',
            'Agency Bill Processing',
            'Direct Bill Reconciliation and Reporting',
            'Data Entry and Reconciliation of Operating Bank, Credit Card, and Loan Accounts',
            'Month-End Closing of Books',
            'Monthly Management Reports',
            '1099/1042 Processing',
          ]}
        />
        <PFSServicePoints
          title='Bookkeeping - Income Tax Accrual Basis (The Above Plus)'
          points={[
            'Accounts Payables',
            'Producers Payables',
            'Accounts Receivables',
            'Prepaid Expenses',
            'Accrued Expenses',
            'Deferred Expenses',
          ]}
        />
        <PFSServicePoints
          title='Bookkeeping - Generally Accepted Accounting Principles Basis (The Above Plus)'
          points={[
            'Asset Management',
            'Liability Management',
            'Revenue Recognition',
            'Business Combinations',
            'Leasing Standards',
            'Current Expected Credit Loss',
            'Assurance Readiness: Audits, Reviews, Compilations',
          ]}
        />

        <PFSServicePoints
          title='Financial Planning and Analysis (Added to the Above)'
          points={[
            'Customized Financial Packages: for Ownership, Investors, Creditors',
            'KPI Dashboards',
            'Financial Strategy Meetings',
            'Budget Development',
            'Forecasting: for growth, exit, succession, recession',
            'Cash Flow Forecasting',
            'Capitalization Table Management',
            'Cost Reductions Analysis',
          ]}
        />
      </ContentContainer>
      <PFSWhyChoosePFS />
      <PFSMeetTheTeam department='FinOps' />
      <br />
      <br />
      <br />
      <br />
      <br />
      <PFSContactCta ctaText='Call us today!' />
    </div>
  )
};

PFSWhatWeDoFinOps.propTypes = {};

export default PFSWhatWeDoFinOps;
